import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Pipe({
  name: 'nimbusDomSanitizer',
  standalone: false,
})
export class DomSanitizerPipe implements PipeTransform {
  public constructor(private sanitizer: DomSanitizer) {}

  public transform(base64string: string): SafeUrl {
    let result: SafeUrl = null;
    if (base64string) {
      result = this.sanitizer.bypassSecurityTrustUrl(base64string);
    }
    return result;
  }
}
